export class ExpressionModel {
  Formula = '';
  Comments?: any;
  ExternalFormula?: string = '';

  constructor(init?: Partial<ExpressionModel>) {
    Object.assign(this, init);
  }

  hasFormula(){
    return !!this.Formula || !!this.ExternalFormula;
  }

  isEmpty(){
    return !this.hasFormula() && !this.Comments;
  }
}
